const accountErrorDataPush = () => {
  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    return digitalData.push({
      error: {
        type: "account",
        message: "there's an issue with your account",
      },
    });
  }
};

export default accountErrorDataPush;
